export const DynamicQuestionFieldTypes = {
  CONTACT: 'contact',
  EMAIL: 'email',
  NUMBER: 'number',
  RADIO: 'radio',
  TEXTAREA: 'textarea',
} as const

export const ConfirmValues = {
  YES: 'yes',
  NO: 'no',
} as const

export const EntityValues = {
  INDIVIDUALS: 'individuals',
  CORPORATES: 'corporates',
  BOTH: 'both',
} as const

export const ClientTypeValues = {
  PROFESSIONAL: 'professional',
  RETAIL: 'retail',
  BOTH: 'both',
} as const
